export default __webpack_public_path__ + "static/media/24.0523df66.jpeg";